import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { t } from "@/i18n";

const STORAGE_KEY = "harf_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(!localStorage.getItem(STORAGE_KEY));
    const openSettings = () => setVisible(true);
    window.addEventListener("harf:open-cookie-settings", openSettings);
    return () => window.removeEventListener("harf:open-cookie-settings", openSettings);
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
    window.dispatchEvent(new CustomEvent("harf:cookie-consent", { detail: value }));
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] border-t bg-card/95 backdrop-blur-xl shadow-2xl">
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col lg:flex-row gap-4 lg:items-center">
        <div className="flex-1 text-sm">
          <strong>{t("cookieconsent.votre_vie_privee_compte")}</strong>{" "}
          {t("cookieconsent.harf_utilise_uniquement_les_elements_necessaires")} <Link to="/legal/cookies" className="text-primary underline">{t("cookieconsent.politique_cookies")}</Link> {t("cookieconsent.et_la")}{" "}
          <Link to="/legal/confidentialite" className="text-primary underline">{t("cookieconsent.politique_de_confidentialite")}</Link>.
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <button onClick={() => choose("refused")} className="rounded-xl border px-3 py-2 text-sm font-semibold hover:bg-secondary">{t("cookieconsent.refuser_l_optionnel")}</button>
          <button onClick={() => choose("accepted")} className="rounded-xl bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90">{t("cookieconsent.tout_accepter")}</button>
        </div>
      </div>
    </div>
  );
}